import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';

export const updateAirportsFieldFromSavedSearch = (
  savedSearchData: SavedTripList,
  bookWidgetFields: BookWidgetFields
) => {
  const airports = [
    {
      fromAirportcode: savedSearchData.originCityCode || '',
      fromCity: '',
      toAirportcode: savedSearchData.destinationCityCode || '',
      toCity: ''
    }
  ];

  return {
    ...bookWidgetFields,
    airportsField: {
      ...bookWidgetFields.airportsField,
      airports
    }
  };
};
